import { combineReducers } from 'redux';

import adjustmentsCriteria from './adjustments.criteria.reducer';
import adjustmentsSchema from './adjustments.schema.reducer';
import buyDowns from './buyDowns.reducer';
import channelPrograms from './channelPrograms.reducer';
import channels from './channels.reducer';
import customAdjustments from './customAdjustments.reducer';
import eligibilityBuilderCriteria from './eligibilityBuilder.criteria.reducer';
import eligibilityBuilderSchema from './eligibilityBuilder.schema.reducer';
import escrowRequirementsCriteria from './escrowRequirements.criteria.reducer';
import escrowRequirementsSchema from './escrowRequirements.schema.reducer';
import investorProductPlanIdentifiers from './investorProductPlanIdentifiers.reducer';
import llpaCapCriteria from './llpaCap.criteria.reducer';
import llpaCapSchema from './llpaCap.schema.reducer';
import llpaTypes from './llpaTypes.reducer';
import miCoverageCriteria from './miCoverage.criteria.reducer';
import miCoverageSchema from './miCoverage.schema.reducer';
import miRulesCriteria from './miRules.criteria.reducer';
import miRulesSchema from './miRules.schema.reducer';
import pricingWorkbench from './pricingWorkbench.reducer';
import programIndexTypes from './programIndexTypes.reducer';
import programs from './programs.reducer';
import rateLockTermsCriteria from './rateLockTerms.criteria.reducer';
import rateLockTermsSchema from './rateLockTerms.schema.reducer';

export const ADJUSTMENTS_CRITERIA_REDUCER = 'adjustmentsCriteria';
export const LLPA_CAP_CRITERIA_REDUCER = 'llpaCapCriteria';
export const MI_COVERAGE_CRITERIA_REDUCER = 'miCoverageCriteria';
export const MI_RULES_REDUCER = 'miRulesCriteria';
export const RATE_LOCK_TERMS_REDUCER = 'rateLockTermsCriteria';
export const ELIGIBILITY_BUILDER_CRITERIA_REDUCER = 'eligibilityBuilderCriteria';

export const ESCROW_REQUIREMENTS_CRITERIA_REDUCER = 'escrowRequirementsCriteria';

const reducer = combineReducers({
  channels,
  programs,
  adjustmentsCriteria,
  miCoverageCriteria,
  miCoverageSchema,
  adjustmentsSchema,
  llpaCapCriteria,
  llpaCapSchema,
  eligibilityBuilderCriteria,
  eligibilityBuilderSchema,
  escrowRequirementsCriteria,
  escrowRequirementsSchema,
  channelPrograms,
  pricingWorkbench,
  programIndexTypes,
  customAdjustments,
  llpaTypes,
  miRulesSchema,
  miRulesCriteria,
  rateLockTermsCriteria,
  rateLockTermsSchema,
  investorProductPlanIdentifiers,
  buyDowns,
});

export default reducer;
